/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PostBudget = {
    type: 'array',
    contains: {
        type: 'Budget',
    },
};